export default __webpack_public_path__ + "static/media/cart.eedb8598.svg";